import { StepLabel } from "@mui/material";
import { useFormActions, useFormState } from "@ngt/forms-core";
import { FC, useCallback } from "react";

interface IStepLabelCheckProps {
    onClick: () => void;
    label: string;
    index: number;
    setComplete: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
}

const StepLabelCheck: FC<IStepLabelCheckProps> = ({ onClick, label, index, setComplete}) => {
    const {fields, errors} = useFormState({errors: true, fields: true})
    const {setTouched} = useFormActions();

    const onNext = useCallback((e: React.MouseEvent) => {
        const hasErrors = fields.reduce((a, b) => {
            if(a)
                return a;
            return errors[b]?.length > 0;
        }, false);

        if (!hasErrors) {
            onClick();
        }
        else {
            onClick();
            setTouched((current) => {
                fields.forEach(path => {
                    current[path] = true;
                });
    
                return current;
            });

            document.querySelector('.error-normal')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }, [errors, fields, index, setComplete])

    return (
        <StepLabel 
            onClick={onNext}
        >
            {label}
        </StepLabel>
    )
}

export default StepLabelCheck;